import { Note } from "../model";

export const newNote = (): Note => ({
  note: "",
  id: "-1",
  created_at: "",
  updated_at: "",
});
